var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignInLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 198,
    viewBox: "0 0 179 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.039,
    cy: 83.6751,
    r: 114.129,
    fill: "url(#paint0_linear_96_4597)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.7318 107.034C109.987 107.034 119.112 97.9093 119.112 86.6536C119.112 75.398 109.987 66.2734 98.7318 66.2734C87.4761 66.2734 78.3516 75.398 78.3516 86.6536C78.3516 97.9093 87.4761 107.034 98.7318 107.034Z",
    stroke: "#F7F7F7",
    strokeWidth: 5.09505,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8403 124.863C70.9724 119.442 75.4759 114.94 80.8986 111.81C86.3212 108.681 92.472 107.033 98.7329 107.033C104.994 107.033 111.145 108.681 116.567 111.811C121.99 114.941 126.493 119.442 129.625 124.864",
    stroke: "#F7F7F7",
    strokeWidth: 5.09505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_4597",
    x1: 218.508,
    y1: -30.4541,
    x2: -63.8885,
    y2: 142.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FFC64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569852,
    stopColor: "#FFA34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#F99952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993897,
    stopColor: "#FF9856"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInLogo);
export default __webpack_public_path__ + "static/media/sign-in-logo.e099f3928ea1c8ff000e624b5998b5d4.svg";
export { ForwardRef as ReactComponent };